const CollectionsUX = () => {
    if ($('#ProductGridContainer').length <= 0) return null;

    const $parent = $('#ProductGridContainer');
    const $items = $parent.find('.grid__item');
    // const $loadMore = $parent.find('.collection-load-more');

    const $sectionParent = $parent.closest('.shopify-section').next('.shopify-section');
    const $artifactToggles = $parent.find('.artifact-toggle');

    const $ctaButtons = $parent.find('.product-detail .primary-btn');

    if ($items.length > 8) {
        const $sectionInsertToGrid = $('<li class="shopify-section-column">').append($sectionParent.children('section'));
        $sectionInsertToGrid.insertAfter($items.eq(7));
    }

    // if ($items.length > 16) {
    //     $loadMore.css('display', 'block')
    //     $items.slice(16).addClass('hidden');
    // } else {
    //     $loadMore.hide();
    // }

    if ($items.length > 16) {
        $items.slice(16).addClass('hidden');
    }


    $(document).ready(function () {
        let lastScrollTop = 0;

        $(window).scroll(function () {
            if ($parent.find('.grid__item.hidden').length <= 0) return;

            const currentScrollTop = $(this).scrollTop();

            if (currentScrollTop > lastScrollTop) {
                const footerTop = $parent.offset().top + $parent.outerHeight();
                const viewportBottom = $(window).scrollTop() + $(window).height();

                const threshold = viewportBottom - ($(window).height() * 0.4);

                if (footerTop <= threshold) {
                    $parent.find('.grid__item.hidden:lt(8)').removeClass('hidden');
                }
            }

            lastScrollTop = currentScrollTop;
        });
    });

    // $loadMore.click(function() {
    //     $parent.find('.grid__item.hidden:lt(8)').removeClass('hidden');
    //     console.log($parent.find('.grid__item.hidden').length);
    //     if ($parent.find('.grid__item.hidden').length <= 0) {
    //         $(this).hide();
    //     }
    // })

    $artifactToggles.click(function () {
        $(this).toggleClass('active');
        $(this).closest('.artifact-card').find('.artifact-details').stop().fadeToggle();
    })

    $ctaButtons.on('mouseenter', function () {
        const $theBtn = $(this);
        $theBtn.find('.btn-text').css('display', 'none');
        $theBtn.find('.product-price').css('display', 'block');
    }).on('mouseleave', function () {
        const $theBtn = $(this);
        $theBtn.find('.product-price').css('display', 'none');
        $theBtn.find('.btn-text').css('display', 'block');
    })
}

export default CollectionsUX;